/* eslint-disable @typescript-eslint/ban-types */
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { getAccountCounts } from 'Services/api/account';
import { logger } from 'Services/logger/logger';
import type { AccountSlugs } from 'Types/account';

export type AccountCounts = Record<AccountSlugs, number>;

export const useAccountBiddingCounts = (): UseQueryResult<AccountCounts> =>
	useQuery({
		onError: (e) => {
			const message = 'There was an issue with fetching bidding counts in account page';
			const error = e instanceof Error ? e : new Error(message);
			logger.error({ context: { extra: { info: message } }, error, message, scope: 'useAccountBiddingCounts' });
		},
		queryFn: () => getAccountCounts(),
		queryKey: ['accountBiddingCounts'],
	});
